'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = createWidgetFactory({
    name: 'expensive_repricing_manager',
    viewClass: require('./view'),
    methods: {
        toggleExpensiveRepricing(isVisible) {
            isVisible = false;
            this.toggleTemplate(isVisible);

            if (isVisible) {
                trackingUtils.trackEvent('repricing_popup', 'repricing_appearances');
            }
        },
    },
});
